export const AMSG_ABI = [
  "function owner() view returns (address)",
  "function admin() view returns (address)",
  "function token() view returns (address)",
  "function adminWallet() view returns (address)",
  "function defaultReferrerId() view returns (uint256)",
  "function totalUsers() view returns (uint256)",
  "function roiTimeframe() view returns (uint256)",
  "function adminWalletFee() view returns (uint256)",
  "function routerPoolFee() view returns (uint256)",
  "function routerPool() view returns (uint256)",
  "function claimFee() view returns (uint256)",
  "function earlyWithdrawFee() view returns (uint256)",
  "function minimumInvestmentUSDT() view returns (uint256)",
  "function investmentMultiple() view returns (uint256)",
  "function dailyWithdrawLimit() view returns (uint256)",
  "function lastClaimWindowStart(uint256) view returns (uint256)",
  "function claimedInWindow(uint256) view returns (uint256)",
  "function planDailyROI(uint256) view returns (uint256)",
  "function planPeriods(uint256) view returns (uint256)",
  "function levelPercentages(uint256) view returns (uint256)",
  "function addressToId(address) view returns (uint256)",
  "function blacklistedUsers(uint256) view returns (bool)",
  "function usedReferralIds(uint256) view returns (bool)",
  "function users(uint256) view returns (address wallet, uint256 id, uint256 referrerId, uint256 totalInvestment, uint256 activeInvestment, uint256 totalEarned, uint256 pendingRewards, uint256 directReferrals, uint256 teamVolume, uint256 lastROIUpdate, bool active)",
  "function userStats(uint256) view returns (uint256 registrationTime, bool isBlacklisted)",
  "function userInvestments(uint256, uint256) view returns (uint256 amount, uint256 timestamp, uint256 roiPaid, uint256 roiEarned, uint256 maxROI, uint8 plan, bool principalWithdrawn, bool active, uint8 investmentType)",
  "function userActivities(uint256, uint256) view returns (uint256 timestamp, uint256 amount, uint8 activityType)",

  "function registerAndInvest(uint256 referrerId, uint256 amount, uint8 planType)",
  "function invest(uint256 amount, uint8 planType)",
  "function claimRewards(uint256 amount)",
  "function withdrawPrincipal(uint256 investmentIndex)",
  "function updateROI(uint256 userId)",

  "function virtualRegister(address userAddress, uint256 referrerId) returns (uint256)",
  "function leaderRegister(address userAddress, uint256 referrerId) returns (uint256)",
  "function virtualInvestment(address userAddress, uint256 usdtAmount, uint256 referrerId, uint8 planType)",
  "function leaderInvestment(address userAddress, uint256 usdtAmount, uint256 referrerId, uint8 planType)",
  "function blacklistUser(uint256 userId, bool status)",

  "function setROITimeframe(uint256 newTimeframe)",
  "function setDefaultReferrer(uint256 newDefaultId)",
  "function setAdmin(address newAdmin)",
  "function transferOwnership(address newOwner)",
  "function updateAdminWalletFee(uint256 newFee)",
  "function updateRouterPoolFee(uint256 newFee)",
  "function withdrawFromRouterPool(address to, uint256 amount)",
  "function updateDailyWithdrawLimit(uint256 newLimit)",
  "function updateClaimFee(uint256 newFee)",
  "function updateEarlyWithdrawFee(uint256 newFee)",
  "function updateMinimumInvestment(uint256 newMinimum)",
  "function updateInvestmentMultiple(uint256 newMultiple)",
  "function updatePlanDailyROI(uint8 planType, uint256 newDailyROI)",
  "function updatePlanPeriods(uint8 planType, uint256 newPeriods)",
  "function updateLevelPercentage(uint256 level, uint256 newPercentage)",
  "function updateLevelRequirement(uint256 level, uint256 selfInvestment, uint256 teamBusiness, uint256 directReferrals)",
  "function updateAdminWallet(address newWallet)",
  "function emergencyWithdraw()",
  "function emergencyWithdrawAmount(uint256 amount)",

  "function getUserInvestmentDetails(uint256 userId) view returns (uint256[] amounts, uint256[] timestamps, uint256[] roiEarned, uint256[] maxROIs, uint256[] maturityTimes, bool[] active, bool[] principalWithdrawn, uint8[] plans, uint8[] investmentTypes)",
  "function getUserBasicInfo(uint256 userId) view returns (address wallet, uint256 totalInvestment, uint256 activeInvestment, uint256 totalEarned, uint256 pendingRewards)",
  "function getUserExtendedInfo(uint256 userId) view returns (uint256 directReferrals, uint256 teamVolume, uint256 referrerId, bool active, bool isBlacklisted)",
  "function getUserLevelCounts(uint256 userId) view returns (uint256[15])",
  "function getUserLevelVolumes(uint256 userId) view returns (uint256[15])",
  "function getUserLevelEligibility(uint256 userId) view returns (bool[15])",
  "function isEligibleForLevel(uint256 userId, uint256 level) view returns (bool)",
  "function getDirectsEligibleAtLevel(uint256 userId, uint256 level) view returns (uint256)",
  "function getLevelUsers(uint256 userId, uint256 level, uint256 page, uint256 pageSize) view returns (uint256[], uint256)",
  "function getUserDirectReferrals(uint256 userId) view returns (uint256[])",
  "function getUserActivities(uint256 userId, uint256 page, uint256 pageSize) view returns (tuple(uint256 timestamp, uint256 amount, uint8 activityType)[], uint256)",
  "function calculateCurrentROI(uint256 userId) view returns (uint256)",
  "function getInvestmentMaturityInfo(uint256 userId, uint256 investmentIndex) view returns (uint256 maturityTime, bool isMatured, uint256 timeRemaining, uint256 expectedRefund, uint256 earlyWithdrawPenalty)",
  "function getContractStats() view returns (uint256 _totalUsers, uint256 totalInvestmentAmount, uint256 activeCount, uint256 blacklistedCount, uint256 contractBalance)",
  "function getROITimeframe() view returns (uint256)",
  "function getROITimeframeInHours() view returns (uint256)",
  "function getROITimeframeInDays() view returns (uint256)",
  "function getFees() view returns (uint256 _adminWalletFee, uint256 _routerPoolFee, uint256 _claimFee, uint256 _earlyWithdrawFee)",
  "function getInvestmentLimits() view returns (uint256, uint256)",
  "function getPlanInfo(uint8 planType) view returns (uint256 dailyROI, uint256 periods, uint256 totalDurationSeconds, uint256 maxROIPercent)",
  "function getAllPlans() view returns (uint256[5] dailyROIs, uint256[5] periods, uint256[5] maxROIBps)",
  "function getLevelInfo(uint256 level) view returns (uint256 percentage, uint256 selfInvestment, uint256 teamBusiness, uint256 directReferrals)",
  "function getAllUserIds(uint256 page, uint256 pageSize) view returns (uint256[], uint256)",
  "function getUserIdByAddress(address userAddress) view returns (uint256)",
  "function getRemainingDailyLimit(uint256 userId) view returns (uint256 remaining, uint256 windowResetsAt)",

  "event UserRegistered(address indexed userAddress, uint256 indexed userId, uint256 indexed referrerId)",
  "event UserInvestment(address indexed userAddress, uint256 indexed userId, uint256 amount, uint8 plan)",
  "event ROIEarned(uint256 indexed userId, uint256 amount)",
  "event LevelIncomeEarned(uint256 indexed userId, uint256 amount, uint256 level, uint256 indexed fromUserId)",
  "event RewardsClaimed(uint256 indexed userId, uint256 amount, uint256 fee)",
  "event PrincipalWithdrawn(uint256 indexed userId, uint256 investmentIndex, uint256 amountReturned, uint256 fee)",
  "event DailyLimitReached(uint256 indexed userId, uint256 attemptedAmount, uint256 availableToday)",
  "event DailyWithdrawLimitUpdated(uint256 newLimit)"
];

export const USDT_ABI = [
  "function balanceOf(address account) view returns (uint256)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
  "function transfer(address to, uint256 amount) returns (bool)"
];
